import React from 'react';
import styles from './GithubIcon.module.css';

interface GithubIconProps {
  size?: number; // px
  connected?: boolean;
  className?: string;
}

export const GithubIcon: React.FC<GithubIconProps> = ({
  size = 18,
  connected = false,
  className,
}) => {
  return (
    <div className={`${styles.container} ${className || ''}`}>
      <img
        src="/icons/GitHub_Invertocat_Black.png"
        alt="GitHub"
        width={size}
        height={size}
        className={styles.iconImg}
      />
      <span
        className={styles.status}
        data-connected={connected ? 'true' : 'false'}
        style={{
          width: Math.max(8, Math.round(size / 3)),
          height: Math.max(8, Math.round(size / 3)),
        }}
      />
    </div>
  );
};

export default GithubIcon;
